module.exports = __webpack_public_path__ + "img/cross.f2bb779e.svg";